// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"az_zWb","containerRightFrame":"az_AWb","outerContainer":"az_BWb","table":"az_CWb","tableHeadCellSticky":"az_DWb","tableRow":"az_EWb","tableCell":"az_FWb"};